enum BadgeVariant {
  Info = 'info',
  Warning = 'warning',
  Danger = 'danger'
}

export { BadgeVariant };
